import type { AxiosRequestConfig } from "axios";



/**
 * En mode agrégé (tous les praticiens), chaque document peut appartenir à un
 * `Client` distinct : l’API doit recevoir `X-Portal-Client-Id` pour résoudre
 * la bonne org (voir PortalAuthGuard).
 */
export const mergePortalDocumentDownloadConfig = (isAllProsMode: boolean, clientId: string | undefined, config: Pick<AxiosRequestConfig, "responseType" | "headers">): AxiosRequestConfig => {
  const extra =
    isAllProsMode && clientId
      ? { headers: { "X-Portal-Client-Id": clientId } }
      : {};
  return { ...config, ...extra };
}
